const messages = {
    account: {
      yourIdentityKey: 'Identitetschlüssel',
      shareToVerify: 'Geben Sie diesen Schlüssel an andere weiter, um Ihr Konto zu verifizieren.',
      textWriteWords: 'Schreiben Sie die folgenden 12 Wörter auf ein Stück Papier oder einen sicheren Ort, den Sie nicht verlieren werden.',
      recoveryWords: 'Erholung Worte',
      yourAccountKey: 'Deine Kontoschlüssel',
      textAccountKey: 'This your raw account key which is generated from your recovery words. But you only  need this for more technical sharing, like with robots',
      btnShowRecoveryWords: 'Recovery-Wörter anzeigen',
      btnShowActualKey: 'Aktuellen Kontoschlüssel anzeigen',
      btnTestRecovery: 'Testen Wiederherstellen',
      btnRestoreAccount: 'Konto Wiederherstellen',
      btnNewShipment: 'Neue Sendung',
      connected: 'Verbunden',
    },
    accountTypes: {
      unspecified: 'Nicht Spezifiziert',
      person: 'Person',
      group: 'Gruppe',
      robot: 'Roboter',
      company: 'Firma',
    },
    auth: {
      myAccount: 'Konto Wiederherstellen',
      haveKey: 'Wenn du habe deine konto schlüssel',
      placeholderKey: 'hier den konto schlüssel eingeben',
      restoreError: 'Bei der Wiederherstellung Ihres Kontos ist etwas schief gelaufen.',
      btnRestoreKey: 'Speichern',
      btnRestoreCancel: 'Abbrechen',
    },
    estimate: 'Schätzung',
    shipment:{
      title: 'Sendung',
      size: 'Größe',
      weight: 'Gewicht',
      shipmentSpeed: 'Versandgeschwindigkeit',
    },
    sizes: {
      sm: 'Klein',
      md: 'Mittel',
      lg: 'Groß',
      xl: 'Extra groß',
    },
    weights: {
      light: 'Hell',
      average: 'Durchschnitt',
      heavy: 'Schwer',
      very: 'Sehr schwer',
      crazy: 'Verrückt',
    },
    speeds: {
      immediate: 'Unmittelbar',
      day: 'Gleicher Tag',
      next: 'Nächster Tag',
      second: 'Übermorgen',
      week: 'Innerhalb einer Woche',
    },
    pickup:{
      title: 'Abholung',
      name: 'Name (wahlweise)',
      contactMethod: 'Kontaktmethode (wahlweise)',
      contact: 'Kontaktdaten',
      address: 'Adresse',
      addressSuffix: 'Adresszusatz',
      city: 'Stadt',
      state:'Land',
      postal:'Postleitzahl',
    },
    destination: {
      title: 'Ziel',
      name: 'Name (wahlweise)',
      contactMethod: 'Kontaktmethode (wahlweise)',
      contact: 'Kontaktdaten',
      address: 'Adresse',
      addressSuffix: 'Adresszusatz',
      city: 'Stadt',
      state:'Land',
      postal:'Postleitzahl',
    },
    delivery: {
      title: 'Einzelheiten',
      payment: 'Bezahlung',
      paymentMethod: 'Methode',
      paymentPayer: 'Zahlender',
      tos: 'Nutzungsbedingungen',
      tosMust: 'Bevor Sie fortfahren, müssen Sie unsere vollständigen Nutzungsbedingungen lesen.',
      tosAgree: 'Sie erklären sich mit unseren Nutzungsbedingungen einverstanden',
      btnCancel: 'Bestellung stornieren',
      btnComplete: 'Bestellung abschließen',
    },
    countries: [
        { "value": "at", "text": "Österreich" },
        { "value": "be", "text": "Belgien" },
        { "value": "br", "text": "Brasilien" },
        { "value": "ca", "text": "Kanada" },
        { "value": "cz", "text": "Tschechische Republik" },
        { "value": "dk", "text": "Dänemark" },
        { "value": "fi", "text": "Finnland" },
        { "value": "fr", "text": "Franreich" },
        { "value": "de", "text": "Deutschland" },
        { "value": "ie", "text": "Irland" },
        { "value": "is", "text": "Island" },
        { "value": "it", "text": "Italien" },
        { "value": "ir", "text": "Iran" },
        { "value": "nl", "text": "Niederlande" },
        { "value": "no", "text": "Norwegen" },
        { "value": "pl", "text": "Polen" },
        { "value": "pt", "text": "Portugal" },
        { "value": "ru", "text": "Russland" },
        { "value": "es", "text": "Spanien" },
        { "value": "ch", "text": "Schweiz" },
        { "value": "se", "text": "Schweden" },
        { "value": "tr", "text": "Türkei" },
        { "value": "uk", "text": "Vereinigtes Königreich" },
        { "value": "us", "text": "Vereinigte Staaten" }
    ]
}

export default messages;
